import { Link } from 'react-router-dom';
export default function QuickLinks(){
    return(
        <>
        <h6 className="widget-title text-white pb-15 mb-35">Quick links</h6>
        <ul className="fot-list fot-flex">
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/faq">FAQs</Link></li>
            <li><Link to="/services">Our Services</Link></li>
            <li><Link to="/team">Meet Our Team</Link></li>
            <li><Link to="/portfolio">All Industries</Link></li>
            <li><Link to="/about">Mission & Values</Link></li>
            <li><Link to="/case-details">Case Studies</Link></li>
            <li><Link to="/history">Our Approach</Link></li>
            <li><Link to="/about">Insights</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
        </ul>
        </>
    )
}